import styled from "styled-components";
import { Typography } from "antd";

const { Title } = Typography;

export const TitleH3 = styled(Title).attrs({
  level: 3,
})`
`;
